// ConsentContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';

type Consent = 'accept' | 'decline' | null;

const ConsentContext = createContext<{
  consent: Consent;
  setConsent: (value: Consent) => void;
}>({
  consent: null,
  setConsent: () => {},
});

export const ConsentProvider = ({ children }: { children: React.ReactNode }) => {
  const [consent, setConsentState] = useState<Consent>(null);

  useEffect(() => {
    const cookies = document.cookie;
    if (cookies.includes('cookies_accepted=accept')) setConsentState('accept');
    else if (cookies.includes('cookies_accepted=decline')) {
      setConsentState('decline');
    }
  }, []);

  const setConsent = (value: Consent) => {
    document.cookie = `cookies_accepted=${value}; path=/; max-age=31536000`;
    setConsentState(value);
  };

  return <ConsentContext.Provider value={{ consent, setConsent }}>{children}</ConsentContext.Provider>;
};

export const useConsent = () => useContext(ConsentContext);
